import React from 'react'

import { IQuestionModelConstructor, IQuestionSchema, QuestionType } from './types'
import { IMaxdiffQuestionSchema } from './Maxdiff/types'

import CheckboxesQuestion from './Checkboxes/Component'
import CheckboxesQuestionModel from './Checkboxes/Model'

import RadioButtonsQuestion from './RadioButtons/Component'
import RadioButtonsQuestionModel from './RadioButtons/Model'

import InstructionQuestion from './Instruction/Component'
import InstructionQuestionModel from './Instruction/Model'

import ImageQuestion from './Image/Component'
import ImageQuestionModel from './Image/Model'

import ImageResponseQuestionModel from './ImageResponse/Model'

import SlidersQuestion from './Sliders/Component'
import SlidersQuestionModel from './Sliders/Model'

import ConversationQuestion from './Conversation/Component'
import ConversationQuestionModel from './Conversation/Model'

import ReorderQuestionModel from './Reorder/Model'

import StarRatingQuestion from './StarRating/Component'
import StarRatingQuestionModel from './StarRating/Model'

import EmoticonsRatingQuestion from './EmoticonsRating/Component'
import EmoticonsRatingQuestionModel from './EmoticonsRating/Model'

import FormsQuestionModel from './Forms/Model'

import OpenEndedQuestion from './OpenEnded/Component'
import OpenEndedQuestionModel from './OpenEnded/Model'

import MaxdiffQuestionModel from './Maxdiff/Model'
import MaxdiffBWQuestionModel from './MaxdiffBW/Model'

import ProgressiveMatrixQuestionModel from './ProgressiveMatrix/Model'

import ConjointQuestionModel from './Conjoint/Model'

import ComboboxQuestion from './Combobox/Component'
import ComboboxQuestionModel from './Combobox/Model'

import ShelfTestModel from './ShelfTest/Model'
import EcommerceModel from './Ecommerce/Model'
import EcommerceQuestion from './Ecommerce/Component'

import DistributeModel from './Distribute/Model'

import PolarityScaleModel from './PolarityScale/Model'

import VideoQuestionModel from './Video/Model'

import TopographyQuestionModel from './Topography/Model'

import VideoResponsePrequalQuestionModel from './VideoResponsePrequal/Model'

import VideoResponseQuestionModel from './VideoResponse/Model'

import RapidAssociationQuestionModel from './RapidAssociation/Model'

import ImpressionDialQuestionModel from './ImpressionDial/Model'

import VanKonanQuestionModel from './VanKonan/Model'

import SideBySideQuestionModel from './SideBySide/Model'

import HeatmapQuestionModel from './Heatmap/Model'

import AdTestingQuestionModel from './AdTesting/Model'

import MenuQuestionModel from './Menu/Model'

import CompositeQuestionModel from './Composite/Model'

import FeedbackQuestion from './Feedback/Component'
import FeedbackQuestionModel from './Feedback/Model'

import VoidQuestion from './Void/Component'
import VoidQuestionModel from './Void/Model'

export function getQuestionModel(questionSchema: IQuestionSchema): IQuestionModelConstructor {
  const questionType = questionSchema?.type
  let QuestionModel: unknown = null
  switch (questionType) {
    case QuestionType.RADIO_BUTTONS: {
      QuestionModel = RadioButtonsQuestionModel
      break
    }
    case QuestionType.CHECKBOXES: {
      QuestionModel = CheckboxesQuestionModel
      break
    }
    case QuestionType.INSTRUCTION: {
      QuestionModel = InstructionQuestionModel
      break
    }
    case QuestionType.OPEN_ENDED: {
      QuestionModel = OpenEndedQuestionModel
      break
    }
    case QuestionType.IMAGE: {
      QuestionModel = ImageQuestionModel
      break
    }
    case QuestionType.IMAGE_RESPONSE: {
      QuestionModel = ImageResponseQuestionModel
      break
    }
    case QuestionType.SLIDERS: {
      QuestionModel = SlidersQuestionModel
      break
    }
    case QuestionType.REORDER: {
      QuestionModel = ReorderQuestionModel
      break
    }
    case QuestionType.SHELF_TEST: {
      QuestionModel = ShelfTestModel
      break
    }
    case QuestionType.STAR_RATING: {
      QuestionModel = StarRatingQuestionModel
      break
    }
    case QuestionType.EMOTICONS_RATING: {
      QuestionModel = EmoticonsRatingQuestionModel
      break
    }
    case QuestionType.FORMS: {
      QuestionModel = FormsQuestionModel
      break
    }
    case QuestionType.ECOMMERCE: {
      QuestionModel = EcommerceModel
      break
    }
    case QuestionType.MAXDIFF: {
      const schemaMD: IMaxdiffQuestionSchema = questionSchema as IMaxdiffQuestionSchema
      QuestionModel = schemaMD.image_grid_columns || schemaMD.best_worst ? MaxdiffBWQuestionModel : MaxdiffQuestionModel
      break
    }
    case QuestionType.PROGRESSIVE_MATRIX: {
      // const schemaMP: IProgressiveMatrixQuestionSchema = questionSchema as IProgressiveMatrixQuestionSchema
      // schemaMP.split = schemaMP.split_pc || (mobile && schemaMP.split_mobile)
      QuestionModel = ProgressiveMatrixQuestionModel
      break
    }
    case QuestionType.CONJOINT: {
      QuestionModel = ConjointQuestionModel
      break
    }
    case QuestionType.CONVERSATION: {
      QuestionModel = ConversationQuestionModel
      break
    }
    case QuestionType.CONJOINT_EXPRESS: {
      QuestionModel = ConjointQuestionModel
      break
    }
    case QuestionType.VIDEO: {
      QuestionModel = VideoQuestionModel
      break
    }
    case QuestionType.VIDEO_RESPONSE: {
      QuestionModel = VideoResponseQuestionModel
      break
    }
    case QuestionType.VIDEO_RESPONSE_PREQUAL: {
      QuestionModel = VideoResponsePrequalQuestionModel
      break
    }
    case QuestionType.COMBOBOX: {
      QuestionModel = ComboboxQuestionModel
      break
    }
    case QuestionType.CASCADE: {
      QuestionModel = ComboboxQuestionModel
      break
    }
    case QuestionType.DISTRIBUTE: {
      QuestionModel = DistributeModel
      break
    }
    case QuestionType.POLARITY_SCALE: {
      QuestionModel = PolarityScaleModel
      break
    }
    case QuestionType.TOPOGRAPHY: {
      QuestionModel = TopographyQuestionModel
      break
    }
    case QuestionType.QUADRANT_ANALYSIS: {
      QuestionModel = TopographyQuestionModel
      break
    }
    case QuestionType.RAPID_ASSOCIATION: {
      QuestionModel = RapidAssociationQuestionModel
      break
    }
    case QuestionType.IMPRESSION_DIAL: {
      QuestionModel = ImpressionDialQuestionModel
      break
    }
    case QuestionType.VAN_KONAN: {
      QuestionModel = VanKonanQuestionModel
      break
    }
    case QuestionType.SIDE_BY_SIDE: {
      QuestionModel = SideBySideQuestionModel
      break
    }
    case QuestionType.HEATMAP: {
      QuestionModel = HeatmapQuestionModel
      break
    }
    case QuestionType.AD_TESTING: {
      QuestionModel = AdTestingQuestionModel
      break
    }
    case QuestionType.MENU: {
      QuestionModel = MenuQuestionModel
      break
    }
    case QuestionType.COMPOSITE: {
      QuestionModel = CompositeQuestionModel
      break
    }
    case QuestionType.FEEDBACK: {
      QuestionModel = FeedbackQuestionModel
      break
    }
    default: {
      return VoidQuestionModel
    }
  }
  return QuestionModel as IQuestionModelConstructor
}

export function getQuestionComponent(questionType: QuestionType, questionSchema: IQuestionSchema): typeof VoidQuestion {
  let QuestionComponent: unknown = null

  switch (questionType) {
    case QuestionType.RADIO_BUTTONS: {
      QuestionComponent = RadioButtonsQuestion
      break
    }
    case QuestionType.CHECKBOXES: {
      QuestionComponent = CheckboxesQuestion
      break
    }
    case QuestionType.INSTRUCTION: {
      QuestionComponent = InstructionQuestion
      break
    }
    case QuestionType.OPEN_ENDED: {
      QuestionComponent = OpenEndedQuestion
      break
    }
    case QuestionType.IMAGE: {
      QuestionComponent = ImageQuestion
      break
    }
    case QuestionType.IMAGE_RESPONSE: {
      QuestionComponent = React.lazy(() => import('./ImageResponse/Component'))
      break
    }
    case QuestionType.SLIDERS: {
      QuestionComponent = SlidersQuestion
      break
    }
    case QuestionType.REORDER: {
      QuestionComponent = React.lazy(() => import('./Reorder/Component'))
      break
    }
    case QuestionType.STAR_RATING: {
      QuestionComponent = StarRatingQuestion
      break
    }
    case QuestionType.EMOTICONS_RATING: {
      QuestionComponent = EmoticonsRatingQuestion
      break
    }
    case QuestionType.FORMS: {
      QuestionComponent = React.lazy(() => import('./Forms/Component'))
      break
    }
    case QuestionType.CONJOINT: {
      QuestionComponent = React.lazy(() => import('./Conjoint/Component'))
      break
    }
    case QuestionType.CONJOINT_EXPRESS: {
      QuestionComponent = React.lazy(() => import('./Conjoint/Component'))
      break
    }
    case QuestionType.COMBOBOX: {
      QuestionComponent = ComboboxQuestion
      break
    }
    case QuestionType.CASCADE: {
      QuestionComponent = ComboboxQuestion
      break
    }
    case QuestionType.ECOMMERCE: {
      QuestionComponent = EcommerceQuestion
      break
    }
    case QuestionType.CONVERSATION: {
      QuestionComponent = ConversationQuestion
      break
    }
    case QuestionType.SHELF_TEST: {
      QuestionComponent = React.lazy(() => import('./ShelfTest/Component'))
      break
    }
    case QuestionType.PROGRESSIVE_MATRIX: {
      QuestionComponent = React.lazy(() => import('./ProgressiveMatrix/Component'))
      break
    }
    case QuestionType.MAXDIFF: {
      const schemaMD: IMaxdiffQuestionSchema = questionSchema as IMaxdiffQuestionSchema
      QuestionComponent =
        schemaMD.image_grid_columns || schemaMD.best_worst
          ? React.lazy(() => import('./MaxdiffBW/Component'))
          : React.lazy(() => import('./Maxdiff/Component'))
      break
    }
    case QuestionType.VIDEO: {
      QuestionComponent = React.lazy(() => import('./Video/Component'))
      break
    }
    case QuestionType.VIDEO_RESPONSE: {
      QuestionComponent = React.lazy(() => import('./VideoResponse/Component'))
      break
    }
    case QuestionType.VIDEO_RESPONSE_PREQUAL: {
      QuestionComponent = React.lazy(() => import('./VideoResponsePrequal/Component'))
      break
    }
    case QuestionType.DISTRIBUTE: {
      QuestionComponent = React.lazy(() => import('./Distribute/Component'))
      break
    }
    case QuestionType.POLARITY_SCALE: {
      QuestionComponent = React.lazy(() => import('./PolarityScale/Component'))
      break
    }
    case QuestionType.TOPOGRAPHY: {
      QuestionComponent = React.lazy(() => import('./Topography/Component'))
      break
    }
    case QuestionType.RAPID_ASSOCIATION: {
      QuestionComponent = React.lazy(() => import('./RapidAssociation/Component'))
      break
    }
    case QuestionType.IMPRESSION_DIAL: {
      QuestionComponent = React.lazy(() => import('./ImpressionDial/Component'))
      break
    }
    case QuestionType.VAN_KONAN: {
      QuestionComponent = React.lazy(() => import('./VanKonan/Component'))
      break
    }
    case QuestionType.SIDE_BY_SIDE: {
      QuestionComponent = React.lazy(() => import('./SideBySide/Component'))
      break
    }
    case QuestionType.HEATMAP: {
      QuestionComponent = React.lazy(() => import('./Heatmap/Component'))
      break
    }
    case QuestionType.AD_TESTING: {
      QuestionComponent = React.lazy(() => import('./AdTesting/Component'))
      break
    }
    case QuestionType.MENU: {
      QuestionComponent = React.lazy(() => import('./Menu/Component'))
      break
    }
    case QuestionType.COMPOSITE: {
      QuestionComponent = React.lazy(() => import('./Composite/Component'))
      break
    }
    case QuestionType.FEEDBACK: {
      QuestionComponent = FeedbackQuestion
      break
    }
    default: {
      return VoidQuestion
    }
  }
  return QuestionComponent as typeof VoidQuestion
}
